import { CSSObject } from '@chakra-ui/react';

export const FormWrapper: CSSObject = {
  fontSize: 'xs',
  '.chakra-switch__label': {
    color: 'white.200',
  },
};
